import { baseImageUrl } from "../../redux/base/types/url";
import { SectorDto } from "../../redux/homepage/type";
import "./style.scss";
import { useSelector } from "react-redux";
import { languageSelector } from "../../redux/languages";
const SectorCard = ({ sector }: { sector: SectorDto }) => {
  const language = useSelector(languageSelector);
  return (
    <a
      href={"/solutions/" + sector.Seo}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <div className="cardContainer">
        <div className="card-wrap">
          <div
            className="sector-card-header one"
            style={{
              background: "linear-gradient(to left, (white), (white))",
              backgroundImage: `url(${
                baseImageUrl + sector.Image.replace("/files\\", "/files/")
              })`,
            }}
          >
            {/* <i className="fas fa-code"></i> */}
          </div>
          <div className="card-content">
            <h3 className="card-title" style={{ height: 50 }}>
              {sector.Name.toLocaleUpperCase(language.Code)}
            </h3>
            <p
              className="card-text"
              style={{ height: 140 }}
              dangerouslySetInnerHTML={{
                __html: sector.ShortContent ? sector.ShortContent : " ",
              }}
            ></p>
            {/* <button className=" card-btn one">
            {t.getString("SectorsCardButton")}
          </button> */}
          </div>
        </div>
      </div>
    </a>
  );
};

export default SectorCard;
